<template>
  <div>
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        v-if="item !== null && item !== undefined"
      >
        <v-container>
          <div class="row">
            <div class="col-12 col-md-4 col-lg-3">
              <!-- <auto-select
                :value.sync="expenseParty"
                :items="columnsDropDownOptions.Enums.ExpenseParty"
                :label="
                  $t('components.balancepayments.expenseform.expense_party')
                "
                class="required"
                :rules="[$rules.required]"
                :slots="true"
                :filter="filterFunc"
                :disabled="true"
              >
                <template v-slot:selection="data">
                  {{ $t("enums." + data.item) }}
                </template>
                <template v-slot:item="data">
                  <v-list-item-content
                    v-text="$t('enums.' + data.item)"
                  ></v-list-item-content>
                </template>
              </auto-select> -->
              <trans-enum
                  :value.sync="expenseParty"
                :items="columnsDropDownOptions.Enums.ExpenseParty"
                :label="
                  $t('components.balancepayments.expenseform.expense_party')
                "
                class="required"
                :rules="[$rules.required]"
                :disabled="true"
                ></trans-enum>
            </div>
            <template
              v-if="expenseParty !== null && expenseParty !== undefined"
            >
              <div class="col-12 col-md-4 col-lg-3">
                <trans-select2
                  v-if="expenseParty === 'Employer'"
                  :value="item"
                  propertyName="Employer"
                  :items="employers"
                  :label="$t('globals.employer')"
                  field="Name"
                  itemValue="Id"
                  :rules="[$rules.required]"
                  class="required"
                  :disabled="true"
                ></trans-select2>
                <trans-select2
                  v-else-if="expenseParty === 'Store'"
                  v-model="item"
                  propertyName="Store"
                  :items="stores"
                  :label="$t('globals.store')"
                  field="Name"
                  itemValue="Id"
                  :rules="[$rules.required]"
                  class="required"
                  :disabled="true"
                ></trans-select2>
              </div>
            </template>
            <template
              v-if="
                (item.Employer !== null && item.Employer !== undefined) ||
                  (item.Store !== null && item.Store !== undefined)
              "
            >
              <div class="col-12 col-md-4 col-lg-3">
                <!-- <auto-select
                  :value.sync="paidParty"
                  :items="columnsDropDownOptions.Enums.PaidParty"
                  :label="$t('components.balancepayments.expenseform.pay_to')"
                  class="required"
                  :rules="[$rules.required]"
                  :slots="true"
                  :filter="filterFunc"
                  :disabled="true"
                >
                  <template v-slot:selection="data">
                    {{ $t("enums." + data.item) }}
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content
                      v-text="$t('enums.' + data.item)"
                    ></v-list-item-content>
                  </template>
                </auto-select> -->
                <trans-enum
                  :value.sync="paidParty"
                  :items="columnsDropDownOptions.Enums.PaidParty"
                  :label="$t('components.balancepayments.expenseform.pay_to')"
                  class="required"
                  :rules="[$rules.required]"
                :disabled="true"
                ></trans-enum>
              </div>
            </template>
            <template v-if="paidParty !== null && paidParty !== undefined">
              <div class="col-12 col-md-4 col-lg-3">
                <trans-select2
                  v-if="paidParty === 'InsuranceCarrier'"
                  v-model="item"
                  propertyName="InsuranceCarrier"
                  :items="insuranceCarriers"
                  :label="$t('globals.insurance_carrier')"
                  field="Name"
                  itemValue="Id"
                  :rules="[$rules.required]"
                  class="required"
                  :disabled="true"
                ></trans-select2>
                <trans-select2
                  v-else-if="paidParty === 'Trustfund'"
                  v-model="item"
                  propertyName="TrustFund"
                  :items="trustFunds"
                  :label="$t('headers.expenses.trust_fund')"
                  field="Name"
                  itemValue="Id"
                  :rules="[$rules.required]"
                  class="required"
                  :disabled="true"
                ></trans-select2>
              </div>
              <div class="col-12 col-md-4 col-lg-3">
                <trans-select2
                  v-model="item"
                  propertyName="Term"
                  :items="terms"
                  :label="$t('headers.contributionterms.name')"
                  field="FullName"
                  itemValue="Id"
                  :rules="[$rules.required]"
                  class="required"
                  :disabled="true"
                ></trans-select2>
              </div>
              <div class="col-12 col-md-4 col-lg-3">
                <v-textarea
                  @change="item.Description = $event"
                  :value="item.Description"
                  :label="$t('globals.description')"
                  class="required"
                  :rules="[$rules.required]"
                ></v-textarea>
              </div>
              <div class="col-12 col-md-4 col-lg-3">
                <currency-textfield
                  :value="item.Amount"
                  @change="item.Amount = $event"
                  :label="$t('globals.amount')"
                  class="required"
                  :rules="[$rules.requiredNum]"
                  :isNegative="item.Type==='Credit'"
                />
                <!-- <no-autocomplete-textfield
                  @blur="amountBlur"
                  :label="$t('globals.amount')"
                  @change="item.Amount = $event"
                  :value="item.Amount"
                  prefix="$"
                  @keydown="currencyKeydown"
                  @keyup="currencyKeyUp"
                  class="required"
                  :rules="[$rules.requiredNum, $rules.decimal]"
                ></no-autocomplete-textfield> -->
              </div>
              <div class="col-12 col-md-4 col-lg-3">
                <!-- <auto-select
                  :value.sync="item.Type"
                  :items="columnsDropDownOptions.Enums.ExpenseType"
                  :label="$t('globals.type')"
                  :rules="[$rules.required]"
                  :slots="true"
                  :filter="filterFunc"
                >
                  <template v-slot:selection="data">
                    {{ $t("enums." + data.item) }}
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content
                      v-text="$t('enums.' + data.item)"
                    ></v-list-item-content>
                  </template>
                </auto-select> -->
                <trans-enum
                  :value.sync="item.Type"
                  :items="columnsDropDownOptions.Enums.ExpenseType"
                  :label="$t('globals.type')"
                  :rules="[$rules.required]"
                ></trans-enum>
              </div>
              <div class="col-12 col-md-4 col-lg-3">
                <currency-textfield
                  :value="item.Amount"
                  @change="item.Amount = $event"
                  :label="$t('globals.amount')"
                  class="required"
                  :rules="[$rules.requiredNum]"
                  :isNegative="item.Type==='Credit'"
                />
                <!-- <no-autocomplete-textfield
                  @blur="amountBlur"
                  :label="$t('globals.amount')"
                  @change="item.Amount = $event"
                  :value="item.Amount"
                  prefix="$"
                  @keydown="currencyKeydown"
                  @keyup="currencyKeyUp"
                  class="required"
                  :rules="[$rules.requiredNum, $rules.decimal]"
                ></no-autocomplete-textfield> -->
              </div>
              <div class="col-12 col-md-4 col-lg-3">
                <pbas-date-picker
                  :label="$t('globals.date')"
                  :value="item.ExpenseDate"
                  @update-date="item.ExpenseDate = $event"
                  :rules="[$rules.required]"
                  class="required"
                />
              </div>
            </template>
          </div>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn text @click="$emit('close')" :loading="saving">
        {{ $t("globals.cancel") }}
      </v-btn>
      <v-btn color="primary" :loading="saving" @click="save" :disabled="!valid">
        {{ $t("globals.save") }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import TransSelect2 from "@/components/TransSelect2";
import { mapActions, mapGetters } from "vuex";
import CurrencyTextfield from "@/components/CurrencyTextfield.vue";
import { sortAlphanum } from "@/alphanumericSort";
import TransEnum from "@/components/TransEnum.vue";
export default {
  components: {
    TransSelect2,
    CurrencyTextfield,
    TransEnum
  },
  props: {
    expense: Object,
    saving: Boolean,
  },
  data: () => ({
    paidParty: null,
    expenseParty: null,
    valid: false,
    loading: false,
    error: null,
    item: null,
    terms: [],
    employers: [],
    stores: [],
    insuranceCarriers: [],
    trustFunds: [],
  }),
  watch: {
    // expense: {
    //   handler(v) {
    //     if (v) {
    //       this.item = v; //JSON.parse(JSON.stringify(v))
    //       this.expenseParty = this.getExpenseParty(v);
    //     }
    //   },
    // },
    expenseParty: {
      async handler(v) {
        if (this.item !== null && this.item !== undefined) {
          switch (v) {
            case "Employer": {
              delete this.item.Store;
              try {
                this.loading = true;
                let employers = (await this.getBillingEmployers({
                  planIdentityId: this.selectedPlan.Id,
                })).data.value.sort((a, b) => {
                  const translatedA = a.Translations.filter(
                    (o) => o.LanguageCode === this.language.language
                  )[0].Name;
                  const translatedB = b.Translations.filter(
                    (o) => o.LanguageCode === this.language.language
                  )[0].Name;
                  return sortAlphanum(translatedA, translatedB);
                });
                this.$nextTick(() => {
                  this.employers = employers;
                });
              } catch (error) {
                this.error = error;
              } finally {
                this.loading = false;
              }
              break;
            }
            case "Store": {
              delete this.item.Employer;
              try {
                this.loading = true;
                this.stores = (await this.getBillingStores({
                  planIdentityId: this.selectedPlan.Id,
                })).data.value;
              } catch (error) {
                this.error = error;
              } finally {
                this.loading = false;
              }
              break;
            }
            default: {
              delete this.item.Employer;
              delete this.item.Store;
              delete this.item.InsuranceCarrier;
              delete this.item.TrustFund;
              break;
            }
          }
        }
      },
    },
    paidParty: {
      async handler(v) {
        if (this.item !== null && this.item !== undefined) {
          switch (v) {
            case "InsuranceCarrier": {
              delete this.item.TrustFund;
              try {
                this.loading = true;
                this.insuranceCarriers = (await this.getBillingInsuranceCarriers(
                  {
                    planIdentityId: this.selectedPlan.Id,
                  }
                )).data.value.map((o) => o.InsuranceCarrier);
              } catch (error) {
                this.error = error;
              } finally {
                this.loading = false;
              }
              break;
            }
            case "Trustfund": {
              delete this.item.InsuranceCarrier;
              try {
                this.loading = true;
                this.trustFunds = (await this.getBillingTrustFund({
                  planIdentityId: this.selectedPlan.Id,
                })).data.value;
              } catch (error) {
                this.error = error;
              } finally {
                this.loading = false;
              }
              break;
            }
            default: {
              delete this.item.Employer;
              delete this.item.Store;
              delete this.item.InsuranceCarrier;
              delete this.item.TrustFund;
              break;
            }
          }
        }
      },
    },
    "item.Employer": {
      async handler(v, old) {
        if (v && old !== v) {
          try {
            this.loading = true;
            this.terms = (await this.getEmployerPaymentTerms({
              planIdentityId: this.selectedPlan.Id,
              employerId: v.Id,
            })).data.value;
          } catch (error) {
            this.error = error;
          } finally {
            this.loading = false;
          }
        }
      },
    },
    "item.Store": {
      async handler(v, old) {
        if (v && old !== v) {
          try {
            this.loading = true;
            this.terms = (await this.getStorePaymentTerms({
              planIdentityId: this.selectedPlan.Id,
              storeId: v.Id,
            })).data.value;
          } catch (error) {
            this.error = error;
          } finally {
            this.loading = false;
          }
        }
      },
    },
    "item.InsuranceCarrier": {
      async handler(v, old) {
        if (v && old !== v) {
          try {
            this.loading = true;
            this.terms = (await this.getBillingTerms2({
              planIdentityId: this.selectedPlan.Id,
            })).data.value;
          } catch (error) {
            this.error = error;
          } finally {
            this.loading = false;
          }
        }
      },
    },
    "item.TrustFund": {
      async handler(v, old) {
        if (v && old !== v) {
          try {
            this.loading = true;
            this.terms = (await this.getBillingTerms2({
              planIdentityId: this.selectedPlan.Id,
            })).data.value;
          } catch (error) {
            this.error = error;
          } finally {
            this.loading = false;
          }
        }
      },
    },
  },
  computed: {
    ...mapGetters("plansMembers", {
      columnsDropDownOptions: "options",
      planColumnsOptions: "planOptions",
      planIdentity: "planIdentity",
    }),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["language"]),
  },
  mounted() {
    if (this.expense) {
      let item =  this.expense;
      if (item.Type === "Credit") {
        item.Amount = Math.abs(item.Amount);
      }
      this.item = item;
      this.expenseParty = this.getExpenseParty(this.expense);
      this.paidParty = this.getPaidParty(this.expense);
      console.log(this.expenseParty, this.expense);
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "getEmployerPaymentTerms",
      "getStorePaymentTerms",
      "getBillingTerms2",
      "getBillingEmployers",
      "getBillingStores",
      "getBillingInsuranceCarriers",
      "getBillingTrustFund",
    ]),
    getExpenseParty(v) {
      if ((v.Employer !== null && v.Employer !== undefined) || (v.EmployerId !== null && v.EmployerId !== undefined)){
        return "Employer";
      } else if ((v.Store !== null && v.Store !== undefined) || (v.StoreId !== null && v.StoreId !== undefined)) {
        return "Store";
      } else {
        return null;
      }
    },
    getPaidParty(v) {
      if (v.InsuranceCarrier !== null && v.InsuranceCarrier !== undefined) {
        return "InsuranceCarrier";
      } else if (v.TrustFund !== null && v.TrustFund !== undefined) {
        return "Trustfund";
      } else {
        return null;
      }
    },
    save() {
      let item = JSON.parse(JSON.stringify(this.item));
      if (item.Type === "Credit") {
        item.Amount = -Math.abs(item.Amount);
      }
      if (this.item.Id !== null && this.item.Id !== undefined) {
        this.$emit("update", item);
      } else {
        this.$emit("add", item);
      }
    },
  },
};
</script>
